import { render, staticRenderFns } from "./MyCreated.vue?vue&type=template&id=650477b2"
import script from "./MyCreated.vue?vue&type=script&lang=js"
export * from "./MyCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports